/* import __COLOCATED_TEMPLATE__ from './seller-profile-completed-projects-card.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import LightboxOverlay from 'sh-www/components/modals/overlays/lightbox';
import { showModal } from 'sh-www/utils/modal-controls';
import { htmlSafe } from '@ember/template';
import { COMPANY_PROFILE__COMPANY_MANAGEMENT__CARD_DESCRIPTION_LENGTHS } from 'sh-www/constants/routes/company-profile';

export default class SellerProfileCompletedProjectsCard extends Component {
  @service('video-thumbnail-from-url') videoThumbnailService;
  @service media;
  @service errorTracker;
  @service session;

  @tracked isDescriptionFullyExpanded = false;
  @tracked isDescriptionTruncated = true;

  get className() {
    return 'SH-c-seller-profile-freelancer-profile__completed-projects-card';
  }

  get viewProjectEnabled() {
    if (this.args.company.canUseCompanyTeams && this.args.application?.companyTeam) {
      const currentUser = this.session.currentUser;
      if (currentUser.isAdmin || currentUser.isCompanyAdmin) {
        return true;
      }
      return currentUser.companyTeams.find(team => this.args.application.companyTeam.id === team.id);
    }
    return true;
  }

  get title() {
    return htmlSafe(this.args.application.title);
  }

  get description() {
    let descriptionText = this.args.application.assignment.descriptionLinkified;

    if (this.isDescriptionFullyExpanded) {
      return htmlSafe(descriptionText);
    }

    if (descriptionText === "") {
      this.isDescriptionTruncated = false;
      return descriptionText;
    }

    if (this.media.isMobile) {
      if (descriptionText.length < COMPANY_PROFILE__COMPANY_MANAGEMENT__CARD_DESCRIPTION_LENGTHS.CHARACTER_COUNT_MOBILE) {
        this.isDescriptionTruncated = false;
      } else {
        this.isDescriptionTruncated = true;
        descriptionText = descriptionText.slice(0, COMPANY_PROFILE__COMPANY_MANAGEMENT__CARD_DESCRIPTION_LENGTHS.CHARACTER_COUNT_MOBILE) + '...';
      }
    }

    else if (this.media.isMediumAndDown) {
      if (descriptionText.length < COMPANY_PROFILE__COMPANY_MANAGEMENT__CARD_DESCRIPTION_LENGTHS.CHARACTER_COUNT_MEDIUM_AND_DOWN) {
        this.isDescriptionTruncated = false;
      } else {
        this.isDescriptionTruncated = true;
        descriptionText = descriptionText.slice(0, COMPANY_PROFILE__COMPANY_MANAGEMENT__CARD_DESCRIPTION_LENGTHS.CHARACTER_COUNT_MEDIUM_AND_DOWN) + '...';
      }
    }

    else if (descriptionText.length < COMPANY_PROFILE__COMPANY_MANAGEMENT__CARD_DESCRIPTION_LENGTHS.CHARACTER_COUNT_LARGE_AND_UP) {
      this.isDescriptionTruncated = false;
    }

    else {
      this.isDescriptionTruncated = true;
      descriptionText = descriptionText.slice(0, COMPANY_PROFILE__COMPANY_MANAGEMENT__CARD_DESCRIPTION_LENGTHS.CHARACTER_COUNT_LARGE_AND_UP) + '...';
    }

    return htmlSafe(descriptionText);
  }

  get descriptionButtonText() {
    return this.isDescriptionFullyExpanded ? 'Read less' : 'Read more';
  }

  get projectDigestThumbnail() {
    const thumbnail = this.args.application.projectdigest.thumbnailUrl;

    if (thumbnail) return thumbnail;
    const { link } = projectDigest;
    if (!link || !isUrl(link)) return null;

    return this.videoThumbnailService.getThumb(link);
  }

  @action
  onShowMoreOrLessClicked(e) {
    e.stopPropagation();
    e.preventDefault();
    this.isDescriptionFullyExpanded = !this.isDescriptionFullyExpanded;
  }

  @action
  onDigestClicked(e) {
    e.stopPropagation();
    e.preventDefault();

    const projectDigest = this.args.application.projectdigest;

    if (projectDigest.embed || projectDigest.link) {
      showModal(this, LightboxOverlay, {
        digestsToShowForVideoCarousel: [projectDigest],
      });
    } else {
      this.errorTracker.error(`onDigestClicked -- Could not find digest media type ${projectDigest.id}`, this);
    }
  }
}
